/** Business phone number rendered across the site. */
export const PHONE_DISPLAY = "+1 645 241 6547";
export const PHONE_HREF = "tel:+" + PHONE_DISPLAY.replace(/\D/g, "");

export const WHATSAPP_NUMBER = "13055221155";
export const whatsappHref = (message: string) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
